module.exports = __webpack_public_path__ + "img/icon-message.c0e78a3f.svg";